import { Component, OnInit } from '@angular/core';
import { HelpCenterService } from '../../shared/Services/HelpCenterService.service';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';


@Component({
  selector: 'lib-help-center-preview',
  templateUrl: './help-center-preview.component.html'
})
export class HelpCenterPreviewComponent implements OnInit {
  HelpCenterItems: any;
  ProductionMode: boolean = false;
  /**ItemNumber:0
  TabNumber:number=0;*/
  language: string = ""
  

   constructor(private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService, private HelpCenterService: HelpCenterService) {
  }

  async ngOnInit(): Promise<void> {
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    
    this.LoadList();
  }

LoadList(){
 
    this.HelpCenterService.GetAll().subscribe((result) => {
      this.HelpCenterItems = result;
  });
}
 
}
